import React from 'react';
import { useTranslation } from 'react-i18next';

export const Services = () => {
  const { t } = useTranslation();
  
  return (
    <section className="services">
      <div className="services-grid">
        <div className="service-card">
          <img src="/images/architecture.jpg" alt="Architecture TI" className="service-image" />
          <h3>{t('architectureTitle')}</h3>
          <p>{t('architectureDesc')}</p>
        </div>
        
        <div className="service-card">
          <img src="/images/implementation.jpg" alt="Implantations informatique" className="service-image" />
          <h3>{t('implementationTitle')}</h3>
          <p>{t('implementationDesc')}</p>
        </div>
        
        <div className="service-card">
          <img src="/images/solutions.jpg" alt="Nos Solutions" className="service-image" />
          <h3>{t('solutionsTitle')}</h3>
          <p>{t('solutionsDesc')}</p>
        </div>
      </div>
    </section>
  );
};
